import React from 'react';
import './FixedButton.css';

export default function FixedButton() {
  return (
    <>
      <div className="floating-contact-buttons">
        {/* Phone Button */}
        <a href="tel:+919342851992" className="floating-btn floating-call-btn" aria-label="Call Us">
          <div className="floating-ring-animation"></div>
          <svg xmlns="http://www.w3.org/2000/svg" className="floating-icon" viewBox="0 0 24 24" fill="#fff">
            <path d="M6.62 10.79a15.91 15.91 0 006.59 6.59l2.2-2.2a1 1 0 011.05-.24 12.72 12.72 0 003.98.64 1 1 0 011 1v3.51a1 1 0 01-1 1A17 17 0 013 5a1 1 0 011-1h3.5a1 1 0 011 1 12.72 12.72 0 00.64 3.98 1 1 0 01-.24 1.05l-2.28 2.28z" />
          </svg>
        </a>

        {/* WhatsApp Button */}
        {/* <a href="https://wa.me/919342851992" className="floating-btn floating-whatsapp-btn" target="_blank" rel="noopener noreferrer" aria-label="WhatsApp Us">
          <div className="floating-ring-animation"></div>
          <svg xmlns="http://www.w3.org/2000/svg" className="floating-icon" viewBox="0 0 24 24" fill="#fff">
            <path d="M20.52 3.48A11.81 11.81 0 0012.07.5 11.55 11.55 0 002.5 16.92L.5 23.5l6.73-2a11.54 11.54 0 006.26 1.73h.05A11.64 11.64 0 0020.52 3.48zM12.1 21.25a9.4 9.4 0 01-4.79-1.32l-.34-.2-4 .94 1.1-3.88-.22-.36a9.45 9.45 0 018-14.12h.1A9.37 9.37 0 1121.5 12a9.31 9.31 0 01-9.4 9.25zm5.15-6.94l-1.5-.73a1.07 1.07 0 00-1.24.2l-.63.65a9.49 9.49 0 01-4.31-4.28l.6-.62a1.07 1.07 0 00.19-1.24l-.74-1.5a1.06 1.06 0 00-1.1-.58c-.71.09-1.57.59-1.57 1.94a5.7 5.7 0 00.36 1.92 10.84 10.84 0 002.14 3.47 10.84 10.84 0 003.47 2.14 5.7 5.7 0 001.92.36c1.35 0 1.85-.86 1.94-1.57a1.07 1.07 0 00-.57-1.1z" />
          </svg>
        </a> */}
      </div>
    </>
  );
}
